import { useRef } from 'react';

export default function IndustriesServed() {
  const scrollRef = useRef<HTMLDivElement>(null);

  const industries = [
    {
      name: 'Legal Services',
      icon: 'ri-scales-3-line',
      description: 'AI systems designed for document workflows, intake, scheduling, and internal efficiency—built with confidentiality and structure in mind.',
      gradient: 'from-blue-900/90 to-blue-800/90'
    },
    {
      name: 'Real Estate',
      icon: 'ri-building-line',
      description: 'Automation and intelligence tools that support lead management, transaction coordination, reporting, and operational scale.',
      gradient: 'from-emerald-900/90 to-emerald-800/90'
    },
    {
      name: 'Accounting & Financial Services',
      icon: 'ri-line-chart-line',
      description: 'Streamlined processes for data handling, client communication, compliance support, and internal workflow clarity.',
      gradient: 'from-indigo-900/90 to-indigo-800/90'
    },
    {
      name: 'Medical Services',
      icon: 'ri-heart-pulse-line',
      description: 'Operational intelligence that improves scheduling, communication, documentation, and staff efficiency—without disrupting patient care.',
      gradient: 'from-teal-900/90 to-teal-800/90'
    },
    {
      name: 'Digital & Professional Services',
      icon: 'ri-briefcase-line',
      description: 'AI-powered systems that enhance service delivery, internal coordination, and scalable execution.',
      gradient: 'from-purple-900/90 to-purple-800/90'
    }
  ];

  const scroll = (direction: 'left' | 'right') => {
    if (scrollRef.current) {
      const scrollAmount = 444;
      scrollRef.current.scrollBy({
        left: direction === 'left' ? -scrollAmount : scrollAmount,
        behavior: 'smooth'
      });
    }
  };

  return (
    <section id="industries" className="bg-white py-28">
      <div className="max-w-[1400px] mx-auto px-20">
        <div className="flex items-end justify-between mb-12">
          <div>
            <span className="text-xs font-semibold text-gray-500 uppercase tracking-[0.15em] mb-4 block">Industries We Serve</span>
            <h2 className="text-5xl font-bold text-gray-900" style={{ fontFamily: 'Crimson Pro, serif' }}>
              Expertise across professional services
            </h2>
          </div>
          <div className="flex items-center gap-3">
            <button 
              onClick={() => scroll('left')}
              className="w-12 h-12 flex items-center justify-center rounded-full border-2 border-gray-300 hover:border-gray-400 hover:bg-gray-50 transition-all cursor-pointer"
            >
              <i className="ri-arrow-left-line text-gray-700 text-xl"></i>
            </button>
            <button 
              onClick={() => scroll('right')}
              className="w-12 h-12 flex items-center justify-center rounded-full border-2 border-gray-300 hover:border-gray-400 hover:bg-gray-50 transition-all cursor-pointer"
            >
              <i className="ri-arrow-right-line text-gray-700 text-xl"></i>
            </button>
          </div>
        </div>

        <div 
          ref={scrollRef}
          className="flex gap-6 overflow-x-auto scrollbar-hide scroll-smooth pb-4"
          style={{ scrollbarWidth: 'none', msOverflowStyle: 'none' }}
        >
          {industries.map((industry, index) => (
            <div 
              key={index}
              className="flex-shrink-0 w-[420px] h-[520px] rounded-3xl overflow-hidden relative group cursor-pointer"
            >
              <div className={`absolute inset-0 bg-gradient-to-br ${industry.gradient}`}></div>
              <div className="relative h-full p-10 flex flex-col">
                <div className="w-12 h-12 flex items-center justify-center mb-8">
                  <i className={`${industry.icon} text-white text-5xl`}></i>
                </div>
                <h3 className="text-3xl font-bold text-white mb-5">{industry.name}</h3>
                <p className="text-base text-white/85 leading-relaxed mb-auto">{industry.description}</p>
                <a href="#contact" className="inline-flex items-center gap-2 text-sm font-semibold text-white hover:gap-3 transition-all cursor-pointer">
                  View solutions
                  <i className="ri-arrow-right-line"></i>
                </a>
              </div>
            </div>
          ))}
        </div>

        <div className="flex items-center justify-center gap-2 mt-8">
          {industries.map((_, index) => (
            <div 
              key={index}
              className={`w-2 h-2 rounded-full ${index === 0 ? 'bg-gray-900' : 'bg-gray-300'}`}
            ></div>
          ))}
        </div>
      </div>
    </section>
  );
}
